import React from "react";
import { MapPinned } from "lucide-react";
import { mapsUrl } from "./geotabFormat.js";

// Épingle vers Google Maps à la position réelle d'un arrêt Geotab.
export default function GeotabMapLink({ lat, lon, title, color, children }) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  return <a href={mapsUrl(lat, lon)} target="_blank" rel="noreferrer noopener" title={title} aria-label={title} style={{ color }}
    className={`inline-flex h-4 shrink-0 items-center justify-center rounded-[4px] border border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-accent ${children ? "gap-1 px-1 text-[11px] font-semibold" : "w-4"}`}>
    <MapPinned size={11} aria-hidden="true" />{children}
  </a>;
}
